import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
export const QuestionAnswerTrueNFalse = ({ question, renderAnswerOption }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const questionContent = JSON.parse((_a = question.questionContent) !== null && _a !== void 0 ? _a : '{}');
    let { userAnswer } = JSON.parse((_c = (_b = question === null || question === void 0 ? void 0 : question.questionAnswer) === null || _b === void 0 ? void 0 : _b.rawAnswer) !== null && _c !== void 0 ? _c : '{}');
    userAnswer = userAnswer === undefined ? [] : userAnswer;
    return (_jsx("ul", Object.assign({ className: "list list--exams-grading" }, { children: [true, false].map(option => {
            return renderAnswerOption(questionContent.correctAnswer === option || questionContent.correctAnswer === `${option}`, userAnswer === option, option, t(`QUESTION.TRUE_FALSE.${option}`.toUpperCase()));
        }) }), void 0));
};
export default QuestionAnswerTrueNFalse;
